import { render } from "./ModalDocumentSendLowBalance.vue?vue&type=template&id=6da71708&scoped=true"
import script from "./ModalDocumentSendLowBalance.vue?vue&type=script&lang=js"
export * from "./ModalDocumentSendLowBalance.vue?vue&type=script&lang=js"

import "./ModalDocumentSendLowBalance.vue?vue&type=style&index=0&id=6da71708&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da71708"]])

export default __exports__